import React from 'react';
import PropTypes from 'prop-types';

// import CONFIG from '../../../config/config';
import FieldGroupComponent from '../../core/FieldGroupComponent/FieldGroupComponent';
import { Button, Form } from 'react-bootstrap';
import LoadingComponent from '../../core/LoadingComponent/LoadingComponent';

import './update-profile.scss';

class UpdatePwdComponent extends React.Component {
    render() {
        const { handleSubmit, submitting, invalid } = this.props;

        return <div>
            {submitting && <LoadingComponent fullScreen />}
            <Form onSubmit={handleSubmit}>
                <FieldGroupComponent
                    label="Current Password"
                    name="currentPassword"
                    type="password"
                    formProps={{
                        maxLength: 30,
                    }}
                />
                <FieldGroupComponent
                    label="New Password"
                    name="password"
                    type="password"
                    formProps={{
                        maxLength: 30,
                    }}
                />
                <FieldGroupComponent
                    label="Confirm New Password"
                    name="confirmPassword"
                    type="password"
                    formProps={{
                        maxLength: 30,
                    }}
                />
                <Button type="submit" disabled={invalid} className="tertiary">Update</Button>
            </Form>
        </div>
    }
}

UpdatePwdComponent.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool,
    invalid: PropTypes.bool.isRequired,
};

export default UpdatePwdComponent;



// WEBPACK FOOTER //
// ./src/components/profile/Profile/UpdatePwdComponent.js